import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PatientActionsMenuComponent } from '../../global-components/patient-actions-menu/patient-actions-menu.component';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { EMPTY_PATIENTS_MIGRATE_UI_STATE, PatientsMigrateFacade, PatientsMigrationUiState } from './patients-migrate.facade';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-patients-migrate',
  imports: [...COMMON_IMPORTS, DialogModule, ProgressSpinnerModule],
  standalone: true,
  templateUrl: './patients-migrate.component.html',
  styleUrl: './patients-migrate.component.css',
})
export class PatientsMigrateComponent {
  private uiStateSub?: Subscription;
  public uiState: PatientsMigrationUiState = EMPTY_PATIENTS_MIGRATE_UI_STATE;

  @Input({ required: true }) orgId!: string;
  @Output() dialogShouldClose = new EventEmitter<void>();

  constructor(private readonly facade: PatientsMigrateFacade) {}

  closeDialog() {
    this.dialogShouldClose.emit();
  }

  async skipDataMigration() {
    await this.facade.recordMigrationSkipped();
    this.closeDialog();
  }

  async migrateData() {
    await this.facade.migratePatients();
    await this.facade.recordMigrationAttempted();
    this.closeDialog();
  }

  async ngOnInit(): Promise<void> {
    this.uiStateSub = this.facade.uiState$.subscribe((state) => {
      this.uiState = state;
    });
    await this.facade.begin(this.orgId);
  }

  ngOnDestroy(): void {
    this.uiStateSub?.unsubscribe();
  }
}
